/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_To_Play_How_Body_2Inputs */

const bn_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাস্টম রান আপনাকে একটি মোড এবং পুল বেছে নিতে দেয়। আপনি বিস্তৃত বিশ্ব রান, শক্ত দেশ-আকারের সেট বা ফোকাস করা আঞ্চলিক পুল খেলতে পারেন।`)
};

const de_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei benutzerdefinierten Läufen können Sie einen Modus und einen Pool auswählen. Sie können breite Weltrunden, engere Ländergruppen oder gezielte regionale Pools spielen.`)
};

const el_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Οι προσαρμοσμένες εκτελέσεις σάς επιτρέπουν να επιλέξετε μια λειτουργία και μια ομάδα. Μπορείτε να παίξετε ευρεία παγκόσμια τρεξίματα, πιο στενά σετ σε μέγεθος χώρας ή εστιασμένες τοπικές πισίνες.`)
};

const en_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom runs let you choose a mode and pool. You can play broad world runs, tighter country-size sets, or focused regional pools.`)
};

const es_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las ejecuciones personalizadas te permiten elegir un modo y un grupo. Puedes jugar en recorridos mundiales amplios, conjuntos de países más reducidos o grupos regionales enfocados.`)
};

const fr_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les parties personnalisées vous permettent de choisir un mode et un pool. Vous pouvez jouer des parties mondiales, des ensembles plus restreints ou des pools régionaux ciblés.`)
};

const hi_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कस्टम रन आपको एक मोड और पूल चुनने देता है। आप व्यापक विश्व रन, कड़े देश-आकार के सेट, या केंद्रित क्षेत्रीय पूल खेल सकते हैं।`)
};

const hu_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az egyéni futtatások lehetővé teszik a mód és a készlet kiválasztását. Játszhat széles világméretű futamokon, szűkebb országméretű szettekben vagy koncentrált regionális készletekben.`)
};

const id_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proses kustom memungkinkan Anda memilih mode dan kumpulan. Anda dapat memainkan pertandingan lari dunia yang luas, set ukuran negara yang lebih ketat, atau kumpulan regional yang terfokus.`)
};

const it_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le corse personalizzate ti consentono di scegliere una modalità e un pool. Puoi giocare a gare mondiali più ampie, a set più ristretti di dimensioni nazionali o a pool regionali mirati.`)
};

const ja_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタム実行では、モードとプールを選択できます。幅広い世界のラン、より狭い国のサイズのセット、または集中した地域のプールをプレイできます。`)
};

const ko_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용자 정의 실행을 통해 모드와 풀을 선택할 수 있습니다. 광범위한 월드 런, 더 엄격한 국가 규모 세트 또는 집중된 지역 풀을 플레이할 수 있습니다.`)
};

const nl_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Met aangepaste runs kun je een modus en pool kiezen. Je kunt brede wereldruns, strakkere landensets of gerichte regionale poules spelen.`)
};

const pl_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niestandardowe przebiegi pozwalają wybrać tryb i pulę. Możesz grać w szerokich rundach światowych, węższych setach dla całego kraju lub w skupionych pulach regionalnych.`)
};

const pt_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As execuções personalizadas permitem que você escolha um modo e um pool. Você pode jogar corridas mundiais amplas, conjuntos de tamanho de país mais restritos ou grupos regionais focados.`)
};

const ru_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользовательские забеги позволяют вам выбрать режим и пул. Вы можете играть в широкие мировые забеги, в более узкие наборы по размеру страны или в специализированные региональные пулы.`)
};

const sv_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassade körningar låter dig välja läge och pool. Du kan spela breda världslopp, tightare set i landsstorlek eller fokuserade regionala pooler.`)
};

const tr_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel çalıştırmalar bir mod ve havuz seçmenizi sağlar. Geniş dünya koşuları, daha dar ülke boyutunda setler veya odaklanmış bölgesel havuzlar oynayabilirsiniz.`)
};

const uk_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спеціальні прогони дозволяють вибрати режим і пул. Ви можете грати в широкі світові пробіжки, щільніші набори в країні або цілеспрямовані регіональні пули.`)
};

const vi_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các lần chạy tùy chỉnh cho phép bạn chọn chế độ và nhóm. Bạn có thể chơi các giải chạy thế giới rộng lớn, các giải quy mô quốc gia chặt chẽ hơn hoặc các nhóm khu vực tập trung.`)
};

const zh_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义运行让您可以选择模式和池。您可以参加广泛的世界赛、更紧凑的国家赛或集中的区域赛。`)
};

const zh_hant_how_to_play_how_body_2 = /** @type {(inputs: How_To_Play_How_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自訂運行讓您可以選擇模式和池。您可以參加廣泛的世界賽、更緊湊的國家賽或集中的區域賽。`)
};

/**
* | output |
* | --- |
* | "Custom runs let you choose a mode and pool. You can play broad world runs, tighter country-size sets, or focused regional pools." |
*
* @param {How_To_Play_How_Body_2Inputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const how_to_play_how_body_2 = /** @type {((inputs?: How_To_Play_How_Body_2Inputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_To_Play_How_Body_2Inputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_how_to_play_how_body_2(inputs)
	if (locale === "de") return de_how_to_play_how_body_2(inputs)
	if (locale === "el") return el_how_to_play_how_body_2(inputs)
	if (locale === "en") return en_how_to_play_how_body_2(inputs)
	if (locale === "es") return es_how_to_play_how_body_2(inputs)
	if (locale === "fr") return fr_how_to_play_how_body_2(inputs)
	if (locale === "hi") return hi_how_to_play_how_body_2(inputs)
	if (locale === "hu") return hu_how_to_play_how_body_2(inputs)
	if (locale === "id") return id_how_to_play_how_body_2(inputs)
	if (locale === "it") return it_how_to_play_how_body_2(inputs)
	if (locale === "ja") return ja_how_to_play_how_body_2(inputs)
	if (locale === "ko") return ko_how_to_play_how_body_2(inputs)
	if (locale === "nl") return nl_how_to_play_how_body_2(inputs)
	if (locale === "pl") return pl_how_to_play_how_body_2(inputs)
	if (locale === "pt") return pt_how_to_play_how_body_2(inputs)
	if (locale === "ru") return ru_how_to_play_how_body_2(inputs)
	if (locale === "sv") return sv_how_to_play_how_body_2(inputs)
	if (locale === "tr") return tr_how_to_play_how_body_2(inputs)
	if (locale === "uk") return uk_how_to_play_how_body_2(inputs)
	if (locale === "vi") return vi_how_to_play_how_body_2(inputs)
	if (locale === "zh") return zh_how_to_play_how_body_2(inputs)
	return zh_hant_how_to_play_how_body_2(inputs)
});